export const ligas_item = [
    {
        "ligas_item_nombre" : "° Agenda de la Secretaria",
        "ligas_item_url" : "/Agenda"
    }
    ,
    {
        "ligas_item_nombre" : "° Movilidad Responsable",    
        "ligas_item_url" : "/Movilidad",         
    }
    ,
    {
        "ligas_item_nombre" : "° Programa Anual (PAAAS)",    
        "ligas_item_url" : "/paaas",         
    }
    ,
    {
        "ligas_item_nombre" : "° Programa Sectorial ",    
        "ligas_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/2023/Documentos/Programa_Sectorial Movilidad y Transporte.pdf",         
    }
    ,
    {
        "ligas_item_nombre" : "° Sistema Tuzobús",    
        "ligas_item_url" : "http://www.tuzobus.gob.mx/",         
    }
    ,
    {
        "ligas_item_nombre" : "° Sistema de Control Interno Institucional",    
        "ligas_item_url" : "/Csii",         
    }
    ,
    {
        "ligas_item_nombre" : "° Padrón de Concesiones",    
        "ligas_item_url" : "https://stch.hidalgo.gob.mx/padron",         
    }
    ,
   {
       "ligas_item_nombre" : "° Dirección General de Movilidad Sustentable",    
       "ligas_item_url" : "/Sustentable",         
   }
  ,
    {
        "ligas_item_nombre" : "°  Dictamen de impacto en la movilidad (RUTS)",    
        "ligas_item_url" : "https://ruts.hidalgo.gob.mx/ver/11393",         
    }
    ,
//    { "ligas_item_nombre" : "° Convocatoria Para el registro de personas Profesionales y Profesionistas para expedir el estudio de impacto a la movilidad.",    
//        "ligas_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/Convocatoria_Profesionistas.pdf", }
    ,
    {
        "ligas_item_nombre" : "°  Registro de personas y profesionistas para expedir el estudio de Impacto a la Movilidad (RUTS)",    
        "ligas_item_url" : "https://ruts.hidalgo.gob.mx/ver/9914"
    }
,
    {
        "ligas_item_nombre" : "°  Padrón de personas profesionales y profesionistas para expedir el estudio de Impacto a la Movilidad",    
        "ligas_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/PADRON_PROFESIONALES_2025.pdf",
    }
]